$(function() {
    var subItemsToggabel = $(".list-sub-toggle");
    subItemsToggabel.each((index, toggleContainer) => {
        var showMoreBtn = $(".list-sub-toggle-more", toggleContainer);
        var showFewerBtn = $(".list-sub-toggle-fewer", toggleContainer);
        var subItemsContainer = $(toggleContainer).prev(".list-sub");
        showMoreBtn.on("click touchstart", e => {
            subItemsContainer.addClass("list-sub--show-all");
        });
        showFewerBtn.on("click touchstart", e => {
            console.log("test");
            subItemsContainer.removeClass("list-sub--show-all");
        });
    });

    var listGraphicItem = $(
        ".module-list-graphic li:not('.list-sub-list-item'):not('.list-item-promoted')"
    );

    // Deprecated do to #107856 in KV DevOps
    //listGraphicItem.each(function() {
    //    var listGraphicIcon = $(this).find($(".list-item-icon"));
    //    $(this).append(listGraphicIcon);
    //});
});
